import { Params, QueryParamsHandling } from '@angular/router';
import { MenuItem } from '../../interfaces/common.interface';
import { BadgeColor } from '../badge/badge.component';

/** Colour variants supported by the tab badge (mirrors `twc-badge` colours). */
export type TabBadgeColor = BadgeColor;

export interface TabItem {
  url?: string;
  title: string;
  order?: number; // Currently only used to save order of items when overflow occurs
  permission?: string;
  badgeNumber?: number;
  /** Badge colour. Defaults to `primary` (mint). */
  badgeColor?: TabBadgeColor;
  queryParams?: Params;
  queryParamHandling?: QueryParamsHandling;
  active?: boolean;
  icon?: string;
  clickFn?: (args?: TabItem) => void;
  draggable?: boolean;
  menuItems?: MenuItem[];
}

export enum TabMenuStyle {
  SIMPLE = 'simple-style',
  DEFAULT = 'default-style',
  RUNNER = 'runner-style',
}
